// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hRUQ","field":"styles_field__350pG","fieldCol":"styles_fieldCol__3LqaY","diffCol":"styles_diffCol__37Pem","diff":"styles_diff__2Zz0q"};